<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <router-link to="account" active-class="router-link-active"
        ><i class="material-icons">person</i>
        <p>Profile</p></router-link
      >
    </li>
    <li>
      <router-link to="cart" active-class="router-link-active"
        ><i class="material-icons">shopping_cart</i>
        <p>Cart</p></router-link
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
